export const columns = [
                        {name:'permissionName', label:'Permiso'},
                        {name:'permission_descript', label:'Descripción'},
                        {name:'name', label:'Company'},
                        {name:'description', label:'Scope'},
                        {name:'actions', label:'Opciones'}
                        ]

